<template>
    <div class="subject-wrapper">
        <Head :title="$tc('header.back')"/>
        <div class="subject-inner" v-if="subjectData">
            <div class="subject-list" v-if="list && list.length">
                <h4 class="page-title" v-if="subjectData.subject">
                    <span>{{subjectData.subject.name}}</span>
                </h4>
                <news-list :list="list"></news-list>
                <p class="loading-notice" @click="getSubjectData">
                    {{isLoading ? $tc('load.loading') : lastList.length >= pageSize ? $tc('load.more') : $tc('load.nomore')}}
                </p>
            </div>
        </div>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import NewsList from '@/components/Channel/NewsList.vue'

import { mapMutations } from 'vuex'

export default {
    name: 'Channel',
    data () {
        return {
            id: '',
            subjectData: null,
            list: [],
            lastList: [],
            pageSize: 10,
            lastDataId: '',
            isLoading: false,
            emptydata: null
        }
    },
    components: {
        NewsList
    },
    created () {
        this.id = this.$route.params.id
        this.getSubjectData()
    },
    mounted () {
        this.$Common.pullLoadData(this.getSubjectData)
    },
    beforeRouteLeave (to, form, next) {
        this.$Common.track('unload', {
            name: this.subjectData && this.subjectData.name,
            id: this.id,
            type: '资讯'
        }).then(() => {
            next()
        })
    },
    methods: {
        ...mapMutations(['setShowLoading', 'setToastData']),
        getSubjectData () {
            if (this.isLoading || (this.list.length && this.lastList.length < this.pageSize)) return
            this.isLoading = true
            this.$Api.getSubjectList({
                subjectId: this.id,
                pageSize: this.pageSize,
                lastDataId: this.lastDataId
            }).then(data => {
                if (data) {
                    !this.subjectData && (this.subjectData = data)
                    this.list.push(...(data.list || []))
                    this.lastList = data.list || []
                    this.lastDataId = data.lastDataId
                    this.isLoading = false
                    data.share && this.share(data.share)
                    this.$Common.track('load', {
                        title: data.subject && data.subject.name,
                        id: this.id,
                        type: '资讯'
                    })
                }
                if (!this.list.length) {
                    this.emptydata = {
                        type: 'nodata'
                    }
                } else {
                    this.emptydata = null
                }
                this.setShowLoading(false)
            }).catch((err) => {
                if (!this.lastDataId) {
                    if (err === 404) {
                        this.emptydata = {
                            type: 'nodata'
                        }
                    } else {
                        this.emptydata = {
                            type: 'nonetwork'
                        }
                    }
                } else {
                    this.setToastData({
                        text: this.$t('default.failed')
                    })
                }
                this.isLoading = false
                this.setShowLoading(false)
            })
        },
        share (obj) {
            this.$nextTick(() => {
                this.$Common.onshare(obj)
            })
        }
    }
}
</script>

<style lang="scss">
    .subject-wrapper {
        font-size: 0;
        padding-bottom: 13.889vw;
        .empty-wrapper {
            height: 60vh;
        }
        .subject-list {
            .news-list-wrapper {
                position: relative;
                margin-top: -4.63vw;
            }
        }
    }
</style>
